import { render, staticRenderFns } from "./ImportantEvent.vue?vue&type=template&id=1d9aef22&scoped=true&"
import script from "./ImportantEvent.vue?vue&type=script&lang=js&"
export * from "./ImportantEvent.vue?vue&type=script&lang=js&"
import style0 from "./ImportantEvent.vue?vue&type=style&index=0&id=1d9aef22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9aef22",
  null
  
)

export default component.exports